<template>
  <div id="preview">
    <v-card
      class="rounded-xl elevation-4 border-0"
      style="background-color: #ffffff; overflow: hidden"
    >
      <v-form ref="form1" v-model="valid1" lazy-validation>
        <!-- Header -->
        <v-card-title
          class="px-6 py-4 d-flex justify-space-between align-center"
          style="background-color: #3a67b1"
        >
          <div class="d-flex align-center">
            <v-icon color="#EDBE38" class="mr-3" size="28"
              >mdi-credit-card-plus-outline</v-icon
            >
            <span class="text-h6 font-weight-bold" style="color: #ffffff">{{
              pageDescription
            }}</span>
          </div>
          <v-btn icon @click="closePrompt" class="ma-0">
            <v-icon color="#FFFFFF">mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <!-- Body -->
        <v-card-text class="pa-6">
          <v-container class="pa-0">
            <v-row>
              <v-col cols="12">
                <div
                  class="mb-2"
                  style="color: #0a0f29; font-weight: 600; font-size: 15px"
                >
                  Payment Id <span style="color: #0097d7">*</span>
                </div>
                <v-text-field
                  v-model="PaymentId"
                  :rules="PaymentIdRules"
                  placeholder="Enter Razorpay Payment ID"
                  required
                  dense
                  outlined
                  background-color="#FFFFFF"
                  color="#0097D7"
                  class="rounded-lg"
                  hide-details
                ></v-text-field>
                <div class="mt-2" style="color: #414042; font-size: 13px">
                  <v-icon size="14" color="#0097D7" class="mr-1"
                    >mdi-information-outline</v-icon
                  >
                  Enter the Razorpay payment transaction ID.
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <!-- Footer -->
        <v-divider style="border-color: rgba(65, 64, 66, 0.1)"></v-divider>
        <v-card-actions class="pa-6 pt-4 d-flex justify-end">
          <v-btn
            @click="closePrompt"
            elevation="0"
            outlined
            class="rounded-lg mr-3 font-weight-bold px-6"
            style="
              color: #414042;
              border-color: #414042;
              text-transform: none;
              height: 44px;
            "
          >
            Close
          </v-btn>
          <v-btn
            :disabled="!valid1"
            @click.prevent="confirmAlert"
            :loading="SubmitFlag"
            elevation="2"
            color="#56BDA3"
            class="rounded-lg font-weight-bold px-8"
            style="color: #ffffff; text-transform: none; height: 44px"
          >
            <v-icon left size="20" color="#FFFFFF"
              >mdi-check-circle-outline</v-icon
            >
            Save
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";

export default {
  mixins: [common],
  components: {},
  props: {
    addRecordPrompt: {
      type: Boolean,
      required: true,
    },
    pageDescription: {
      type: String,
    },
  },
  data() {
    return {
      valid1: true,
      valid2: true,
      LoadingFlag: false,
      SearchFlag: false,
      SubmitFlag: false,

      rows: [],

      PaymentId: "",
      PaymentIdRules: [(v) => !!v || "Payment Id is required"],
    };
  },
  computed: {},
  watch: {},
  created() {
    // this.initialize()
  },
  methods: {
    validateForm() {
      console.log("validateForm called");
      this.$refs.form1.validate();
    },
    resetForm() {
      console.log("resetForm called");
      this.$refs.form1.reset();
      //   this.$refs.ProfilePicture.reset();
    },
    resetValidation() {
      console.log("resetValidation called");
      this.$refs.form1.resetValidation();
    },
    closePrompt() {
      console.log("closePrompt called");
      this.$emit("hideAddRecordPrompt");
    },
    refreshPageData() {
      console.log("refreshPageData called");
    },
    confirmAlert() {
      var validate1 = this.$refs.form1.validate();
      console.log("validate1=" + validate1);
      if (validate1) {
        Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: `Save`,
          confirmButtonColor: "#3085d6",
          cancelButtonText: `Cancel`,
          cancelButtonColor: "#d33",
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            this.submitForm();
          } else {
            this.sweetAlert("error", "You cancelled the process", true);
          }
        });
      } else {
        this.toast("error", "Kindly fill the required fields", true);
      }
    },
    submitForm() {
      console.log("submitForm is called");

      var validate1 = this.$refs.form1.validate();
      console.log("validate1=" + validate1);

      //   validate1 = false;

      if (validate1) {
        this.SubmitFlag = true;

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/senior/members/add-online-payment";
        var upload = {
          UserInterface: 1,
          PaymentId: this.PaymentId,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var successTxt = "";
        var errorTxt = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.SubmitFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            output = response.data.output;
            records = response.data.records;
            console.log("output=" + output + ", flag=" + flag);
            successTxt = response.data.success;
            errorTxt = response.data.error;
            console.log("successTxt=" + successTxt + ", errorTxt=" + errorTxt);

            if (flag == 1) {
              thisIns.sweetAlert("success", output, true);
              thisIns.resetForm();
              thisIns.closePrompt();
            } else {
              thisIns.sweetAlert("error", output, false);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.SubmitFlag = false;
          });
      } else {
        var message = "";
        if (!validate1) {
          message += "Kindly fill the required fields";
        }
        thisIns.sweetAlert("error", message, false);
      }
    },
  },
  beforeMount() {
    this.refreshPageData();
  },
};
</script>
